// Lower-cased filename extension without the leading dot, or "" when the name has
// no usable extension (no dot, a leading-dot dotfile, or a trailing dot).
export const getFileExtension = (name: string): string => {
  const lastDotIndex = name.lastIndexOf(".");
  if (lastDotIndex <= 0 || lastDotIndex === name.length - 1) {
    return "";
  }

  return name.slice(lastDotIndex + 1).toLowerCase();
};

// Filename without its extension, preserving any earlier dots (e.g. "a.b.pdf" -> "a.b").
// Names without a usable extension (see getFileExtension) are returned unchanged.
export const stripFileExtension = (name: string): string => {
  const lastDotIndex = name.lastIndexOf(".");

  return lastDotIndex <= 0 ? name : name.slice(0, lastDotIndex);
};

// Validates an uploaded file against an allow-list, preferring the browser-reported MIME
// type and falling back to the filename extension only when the MIME type is absent.
export const isSupportedFileType = (
  file: File,
  allowedMimeTypes: ReadonlySet<string>,
  allowedExtensions: ReadonlySet<string>
): boolean => {
  const mimeType = file.type?.toLowerCase() ?? "";
  if (mimeType) {
    return allowedMimeTypes.has(mimeType);
  }

  const extension = getFileExtension(file.name);

  return !!extension && allowedExtensions.has(extension);
};
